import { render, staticRenderFns } from "./rich-editor.vue?vue&type=template&id=46e362af&"
import script from "./rich-editor.vue?vue&type=script&lang=js&"
export * from "./rich-editor.vue?vue&type=script&lang=js&"
import style0 from "./rich-editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "src/demo/packageEditor/rich-editor.vue"
export default component.exports